import axios from 'axios'
import axiosConfig from './modules/axiosConfig'
import PageHome from './pages/Home.js'
import PageDsSections from './pages/ds_sections.js'
import PageLogin from './pages/Login'
import UseMouseOrKeyboard from './modules/UseMouseOrKeyboard'
import DesignSystem from './DesignSystem/DesignSystem'
import { register } from 'swiper/element/bundle'
import logs from './utils/logs'
import ripple from './modules/ripple'
import formErros from './modules/formErros'
import animaAoScroll from './animation/animaAoScroll'
import animateSetup from './animation/animateSetup'
import scriptMenu from './modules/menu'
import initCounterUp from './modules/counter'
import scriptFooter from './modules/footer'
import Consultancies from './pages/Consultancies'
import Single from './pages/Single'
import Work from './pages/work'
import PageParceiro from './pages/page_parceiro'
import PageClientes from './pages/Clientes'
import contatoForm from './modules/form-contato'
import EditorJs from './modules/editorJs'

// Init
GLOBAL.DesignSystem = DesignSystem({})
register()

// Config
axiosConfig({ csrf: GLOBAL.context?.csrf }, axios)
UseMouseOrKeyboard()
ripple()
formErros()
animateSetup()
animaAoScroll()

if (document.querySelector('[js-page="home"]')) {
  initCounterUp(); 
}

if (document.querySelector('[js-page="single"]')) {
  initCounterUp(); 
}

scriptMenu()
PageHome()
Consultancies()
Single()
Work()
PageParceiro()
PageDsSections()
PageLogin()?.init()
PageClientes()
scriptFooter()

if (document.querySelector('[js-page="home"]') || document.querySelector('[js-page="contato"]')) {
	contatoForm()
}

EditorJs()
logs()
